import { gql } from '@apollo/client';

export const GET_ENTERPRISECONTEXT_DATA = gql`
  query ($v1: EnterpriseContextFiltersType) {
    enterpriseContext {
      get(filters: $v1) {
        id
        createdAt
        updatedAt
        enterpriseContext
      }
    }
  }
`;

export const GET_TAXONOMY_INDUSTRY_DATA = gql`
  query ($v1: TaxonomyFunctionFiltersType, $v2: [String!]) {
    industry {
      fetch {
        id
        name
      }
    }
    taxonomyFunction {
      fetch(filters: $v1, sort: $v2) {
        id
        name
        taxonomy {
          industry {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_AI_ENABLER_DATA = gql`
  query ($v1: AiEnablerFiltersType, $v2: [String!]) {
    aiEnabler {
      fetch(filters: $v1, sort: $v2) {
        svg
        name
        short
        id
      }
    }
  }
`;

export const GET_AI_SOLUTIONS_DATA = gql`
  query ($v1: AiSolutionFiltersType, $v2: [String!]) {
    aiSolution {
      fetch(filters: $v1, sort: $v2) {
        id
        name
        valueDriversScores
        impactAssessment
        favorite
      }
    }
  }
`;

export const GET_AI_SOLUTIONS_LIST_DATA = gql`
  query ($v1: AiSolutionFiltersType, $v2: PaginationInput, $v3: AiSolutionFiltersType) {
    aiSolution {
      fetch(filters: $v1, pagination: $v2) {
        id
        name
        description
        func {
          id
          name
        }
        favorite
      }
      count(filters: $v3)
    }
  }
`;

export const GET_AI_SOLUTION_BY_ID = gql`
  query ($v1: AiSolutionFiltersType) {
    aiSolution {
      get(filters: $v1) {
        id
        name
        description
        agentCollaboration
        stepsInvolved
        aiOpportunitiesUsed
        impactValue
        impactRationale
        dataRequirements
        dataSources
        implementationConsiderations
        keyConsiderations
        benefits
        potentialChallenges
        favorite
        valueDriversScores
        impactAssessment
      }
    }
  }
`;

export const GET_AI_SOLUTION_BY_SUBID = gql`
  query ($v1: TaxonomySubProcessFiltersType) {
    taxonomySubProcess {
      get(filters: $v1) {
        id
        name
        description
        process {
          id
          e2e {
            id
            func {
              id
            }
          }
        }
      }
    }
  }
`;

export const PROCESS_STATUS = gql`
  query GetNewSolution($solutionId: String!) {
    newSolution {
      get(filters: { id: $solutionId }) {
        processStatus
        notifyForElaborateFile
      }
    }
  }
`;
export const GET_PROCESS_STATUS = gql`
  query GetProcessStatus($solutionId: String!) {
    newSolution {
      get(filters: { id: $solutionId }) {
        processStatus
        notifyForOpportunity
      }
    }
  }
`;
